function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { INPUT } from "../../components/form-styles";

/*
 * Per-email style overrides (2026-10-04). Brand defaults come from the brand
 * kit; an override is stored on design.style = {accent, textColor, background,
 * buttonRadius, fontFamily} with ONLY the overridden keys. The server renderer
 * may ignore unknown keys today; the composer injects the overrides into the
 * preview HTML so people see the effect.
 */

export const FONTS = [["", "Brand default"], ["-apple-system, 'Segoe UI', Helvetica, Arial, sans-serif", "System sans"], ["Georgia, 'Times New Roman', serif", "Georgia (serif)"], ["'Helvetica Neue', Helvetica, Arial, sans-serif", "Helvetica / Arial"], ["Verdana, Geneva, sans-serif", "Verdana"], ["'Trebuchet MS', Tahoma, sans-serif", "Trebuchet"], ["'Courier New', Courier, monospace", "Courier (mono)"]];
const RADII = [["", "Brand default"], ["0", "Square"], ["4", "Slightly rounded"], ["8", "Rounded"], ["999", "Pill"]];
const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

/** Brand defaults (brand kit when present, otherwise the renderer's own) for the panel's "default" labels. */
export function brandDefaults(brand) {
  const b = brand || {};
  return {
    accent: HEX.test(String(b.accent || "").trim()) ? b.accent.trim() : "#1f2937",
    textColor: HEX.test(String(b.textColor || "").trim()) ? b.textColor.trim() : "#26261f",
    background: HEX.test(String(b.background || b.backgroundColor || "").trim()) ? (b.background || b.backgroundColor).trim() : "#f4f4f2",
    buttonRadius: b.buttonRadius != null && b.buttonRadius !== "" ? Number(b.buttonRadius) : 6,
    fontFamily: b.fontFamily || b.emailFont || "-apple-system, 'Segoe UI', Helvetica, Arial, sans-serif"
  };
}

/** CSS injected into the preview for the overrides (only the keys set). */
export function overrideCss(style) {
  const s = style || {};
  const rules = [];
  if (s.background) rules.push(`body{background:${s.background} !important}`, `body > table, body > center > table, body > div{background:${s.background} !important}`);
  if (s.textColor) rules.push(`body, td, p, li, h1, h2, h3, h4{color:${s.textColor} !important}`);
  if (s.fontFamily) rules.push(`body, td, p, li, h1, h2, h3, h4, a, span, div{font-family:${s.fontFamily} !important}`);
  if (s.accent) rules.push(`a{color:${s.accent} !important}`, `a[style*="background"], td[style*="background"] a, [class*="btn"], [class*="button"]{background-color:${s.accent} !important;border-color:${s.accent} !important;color:#fff !important}`, `[style*="border-top"]{border-top-color:${s.accent} !important}`);
  if (s.buttonRadius != null && s.buttonRadius !== "") rules.push(`a[style*="background"], td[style*="background"] a, [class*="btn"], [class*="button"]{border-radius:${Number(s.buttonRadius)}px !important}`);
  return rules.join("\n");
}
export function applyStyleToHtml(html, style) {
  const css = overrideCss(style);
  if (!html || !css) return html;
  const tag = `<style data-cmp-style>${css}</style>`;
  if (/<\/head>/i.test(html)) return html.replace(/<\/head>/i, `${tag}</head>`);
  if (/<body[^>]*>/i.test(html)) return html.replace(/<body[^>]*>/i, m => `${m}${tag}`);
  return tag + html;
}
export default class StylePanel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      open: false
    });
  }
  render() {
    const {
      style,
      brand,
      onChange
    } = this.props;
    const {
      open
    } = this.state;
    const s = style || {};
    const d = brandDefaults(brand);
    const n = Object.keys(s).filter(k => s[k] != null && s[k] !== "").length;
    const set = (k, v) => {
      const next = {
        ...s
      };
      if (v == null || v === "") delete next[k];else next[k] = v;
      onChange(Object.keys(next).length ? next : null);
    };
    const color = (k, label) => {
      const cur = s[k] || "";
      const shown = HEX.test(cur) ? cur : d[k];
      return /*#__PURE__*/React.createElement("div", {
        className: "cmp-style-field"
      }, /*#__PURE__*/React.createElement("label", null, label), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("input", {
        type: "color",
        value: shown,
        onChange: e => set(k, e.target.value)
      }), /*#__PURE__*/React.createElement("input", {
        style: {
          ...INPUT,
          width: 100,
          padding: "4px 7px"
        },
        value: cur,
        placeholder: d[k],
        onChange: e => set(k, e.target.value)
      }), cur ? /*#__PURE__*/React.createElement("a", {
        className: "cmp-link dim",
        onClick: () => set(k, "")
      }, "brand") : /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "brand default")));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "cmp-style" + (open ? " open" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "cmp-style-head",
      onClick: () => this.setState({
        open: !open
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "cmp-caret"
    }, open ? "▾" : "▸"), /*#__PURE__*/React.createElement("b", null, "Style"), /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, n ? `${n} override${n === 1 ? "" : "s"} for this email` : "brand defaults"), /*#__PURE__*/React.createElement("span", {
      className: "cmp-swatches"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        background: s.accent || d.accent
      },
      title: "accent"
    }), /*#__PURE__*/React.createElement("i", {
      style: {
        background: s.background || d.background
      },
      title: "background"
    }), /*#__PURE__*/React.createElement("i", {
      style: {
        background: s.textColor || d.textColor
      },
      title: "text"
    })), n ? /*#__PURE__*/React.createElement("a", {
      className: "cmp-link right",
      onClick: e => {
        e.stopPropagation();
        onChange(null);
      }
    }, "Reset to brand") : null), open ? /*#__PURE__*/React.createElement("div", {
      className: "cmp-style-body"
    }, color("accent", "Accent (buttons, links)"), color("textColor", "Text color"), color("background", "Background"), /*#__PURE__*/React.createElement("div", {
      className: "cmp-style-field"
    }, /*#__PURE__*/React.createElement("label", null, "Button shape"), /*#__PURE__*/React.createElement("select", {
      style: {
        ...INPUT,
        width: "auto"
      },
      value: s.buttonRadius != null && s.buttonRadius !== "" ? String(s.buttonRadius) : "",
      onChange: e => set("buttonRadius", e.target.value === "" ? "" : Number(e.target.value))
    }, RADII.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, v === "" ? `${l} (${d.buttonRadius}px)` : l)))), /*#__PURE__*/React.createElement("div", {
      className: "cmp-style-field"
    }, /*#__PURE__*/React.createElement("label", null, "Font"), /*#__PURE__*/React.createElement("select", {
      style: {
        ...INPUT,
        width: "auto",
        maxWidth: "100%"
      },
      value: s.fontFamily || "",
      onChange: e => set("fontFamily", e.target.value)
    }, FONTS.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, v === "" ? `${l} (${brand && (brand.fontFamily || brand.emailFont) ? "brand kit" : "system sans"})` : l)))), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "6px 0 0",
        gridColumn: "1 / -1"
      }
    }, "Masthead, logo and the compliance footer always come from ", /*#__PURE__*/React.createElement("a", {
      href: "/Settings/Brand"
    }, "Settings \u2192 Brand kit"), ". These overrides apply to this email only; the preview shows them now, the sent mail follows once the mail service reads them.")) : null);
  }
}